<template>
    <div :class="{'mt4' : index !== 0}">
        <LabeledControl :class="{ 'pr4' : !smallOrLess }" class="w-100" :label="'Address ' + (index + 1)">
            <Textbox v-model="data.address"/>
        </LabeledControl>

        <div :class="{ 'flex items-center' : !smallOrLess }" class="mt3">
            <LabeledControl :class="{ 'pr4 w-50' : !smallOrLess }" class="pb3 pb0-ns" label="City">
                <Textbox v-model="data.city"/>
            </LabeledControl>
            <div :class="{' w-50' : !smallOrLess}" class="flex">
                <LabeledControl class="mr4 w-50" label="Province">
                    <Dropdown>
                        <option>{{data.province}}</option>
                    </Dropdown>
                </LabeledControl>
                <LabeledControl class="w-50" label="Postal Code">
                    <Textbox v-model="data.postal_code"/>
                </LabeledControl>
            </div>
        </div>
    </div>
</template>

<script>
import LabeledControl from '@/components/controls/LabeledControl.vue';
import Textbox from '@/components/controls/Textbox.vue';
import Dropdown from '@/components/controls/Dropdown.vue';

export default {
    data() {
        return {
            userInfo: {
                password: 'password01'
            }
        };
    },
    components: {
        LabeledControl,
        Textbox,
        Dropdown
    },
    computed: {
        smallOrLess() {
            return this.$mq === 'xs' || this.$mq === 'sm';
        }
    },
    props: {
        data: {
            type: Object
        },
        index: {
            type: Number
        }
    }
};
</script>
